export default __webpack_public_path__ + "static/media/char_body_009.497d25f0.png";